<template>
  <div class="info-page">
    <div class="info-index" v-loading="!init">
      <el-form class="settings-form">
        <el-form-item label="Название проекта">
          <div class="label">
            <span>{{ this.$store.state.project.name }}</span>
          </div>
        </el-form-item>
        <el-form-item label="Адрес проекта">
          <div class="label">
            <span>{{ this.$store.state.project.address }}</span>
          </div>
        </el-form-item>
        <el-form-item label="Описание  проекта">
          <div class="label">
            <span>{{ this.$store.state.project.description }}</span>
          </div>
        </el-form-item>

        <div v-if="this.$store.state.project.deadline_accounting">
          <el-form-item label="Директивный срок начала проекта">
            <span>{{ this.$store.state.project.start_date || '-' }}</span>
          </el-form-item>
          <el-form-item label="Директивный срок окончания проекта">
            <span>{{ this.$store.state.project.end_date || '-' }}</span>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import LineChart from '../../../components/Chart.js';
import firebase from 'firebase';
import dayjs from 'dayjs';
import VueWeather from 'vue-weather-widget';

window.geocoder = new window.google.maps.Geocoder();

export default {
  name: 'Index',
  components: {
    LineChart,
    VueWeather,
  },
  data() {
    return {
      datacollection: null,
      today_reports: '-',
      init: false,
      latitude: null,
      longitude: null,
    };
  },
  async mounted() {
    setTimeout(() => {
      document.getElementsByClassName('bm-burger-button')[0].click()
      this.init = true;
    }, 1000);
  },
  methods: {
    geocodeAddress(inputAddress) {
      return new Promise((resolve) => {
        window.geocoder.geocode({
          'address': inputAddress,
        }, (results) => {
          resolve();
          try {
            this.latitude = results[0].geometry.location.lat();
            this.longitude = results[0].geometry.location.lng();
          } catch (e) {
            this.latitude = 55.751244;
            this.longitude = 37.618423;
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .info-page {
    max-width: 600px;
    margin: 0 auto;
    background: #f2f2f2;
    padding: 5px 20px;
    border-radius: 5px;
  }
</style>
<style lang="scss">
.vww__day-bar span {
  font-size: 14px;
  font-weight: 500;
}
.info-page .el-form-item {
  flex-direction: column;
  display: flex;
}

.info-page .el-form-item__content {
  text-align: left;
}

.info-page .el-form-item__label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Info/Index.vue